// extracted by mini-css-extract-plugin
export default {"totalPrice":"XM_fFD","withSeatingPlan":"Jyj6Sg","totalPriceRow":"H3KVLq"};